import { TextContent } from "../../types/localMessage";

export function parseTextContent(text: string): TextContent[] {
  const combinedRegex = /https?:\/\/(?:[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*|\d{1,3}(?:\.\d{1,3}){3}|localhost)(?::\d+)?(?:\/[^\s]*)?|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/[^\s]*)?|\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;  

  const result: TextContent[] = [];  
  let lastIndex = 0;  

  let match;  
  while ((match = combinedRegex.exec(text)) !== null) {  
    if (match.index > lastIndex) {  
      result.push({ type: "text", content: text.slice(lastIndex, match.index) });  
    }  

    const matchedText = match[0];  
    const am = matchedText.match(/@/g);
    const onea = am?.length === 1;
    const slashidx = matchedText.indexOf("/")
    const type = onea && slashidx < 0 ? "mail" : "link";  
    result.push({ type, content: matchedText });  

    lastIndex = combinedRegex.lastIndex;  
  }  

  if (lastIndex < text.length) {  
    result.push({ type: "text", content: text.slice(lastIndex) });  
  }  

  return result;
}
